import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import colors from 'vuetify/es5/util/colors'


Vue.use(Vuetify, { iconfont: 'mdi', customProperties: true })

export default new Vuetify({
  theme: {
    themes: {
      dark : {  
        //ps: temu dark pouzivat nebudeme
        primary: colors.red.base,
        secondary: colors.blue.base,
        accent: colors.deepOrange.base,
        error: colors.red.base,
        warning: colors.orange.base,
        info: colors.lightBlue.base,
        success: colors.lightGreen.base,
        javaColor: colors.red.base 
      },
      light : { 
        //ps: dodefinovane vlastnosti
        primary: colors.blue.darken2,
        secondary: colors.green.base,
        accent: colors.deepOrange.base,
        error: colors.red.base,
        warning: colors.orange.base,
        info: colors.lightBlue.base,
        success: colors.green.darken2,
        buttonColor: colors.blue.darken2,
        javaColor: colors.red.base 
      }
    }
  },
  icons: {
    iconfont: 'mdi',
  },
});
